/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * all countries translated in the given locale
 * @export
 * @interface CompanyTypesResponseCountriesInner
 */
export interface CompanyTypesResponseCountriesInner {
    /**
     * 
     * @type {string}
     * @memberof CompanyTypesResponseCountriesInner
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypesResponseCountriesInner
     */
    countryName: string;
}

/**
 * Check if a given object implements the CompanyTypesResponseCountriesInner interface.
 */
export function instanceOfCompanyTypesResponseCountriesInner(value: object): value is CompanyTypesResponseCountriesInner {
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('countryName' in value) || value['countryName'] === undefined) return false;
    return true;
}

export function CompanyTypesResponseCountriesInnerFromJSON(json: any): CompanyTypesResponseCountriesInner {
    return CompanyTypesResponseCountriesInnerFromJSONTyped(json, false);
}

export function CompanyTypesResponseCountriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypesResponseCountriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'locale': json['locale'],
        'countryName': json['countryName'],
    };
}

export function CompanyTypesResponseCountriesInnerToJSON(value?: CompanyTypesResponseCountriesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'locale': value['locale'],
        'countryName': value['countryName'],
    };
}

